import React from "react";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import Hero from "../../components/Downloads/Hero/Hero";
import Box from "../../components/Downloads/box/Box";
import UpButton from '../../components/UpButton';
//============================================
import {products_last_part} from '../../Data/product_new' ;
import SubServPart from '../../components/SubServPart' ;
import { Helmet } from "react-helmet";
//== 
import  { useContext ,useEffect } from 'react';
import { LanguageContext } from '../../context/LanguageContext';
//==
const Downloads = ({scroll , lang}) => {
  //---
  const { toggleLanguage } = useContext(LanguageContext);
  useEffect(() => {
    toggleLanguage(lang)
  },);
  //--- 
  return (
    <div>
      <Helmet>
        <title>Millensys - Downloads</title>
      </Helmet>
      <UpButton scroll={scroll} />
      <div>
        <Header />
        <Hero />
        <Box/>
        <SubServPart products={products_last_part} title={'Value For Everyone'} overview={'Create and deliver a value for all stakeholders'}/>
        <Footer />
      </div>
    </div>
  );
};

export default Downloads;
